module.exports = __webpack_public_path__ + "static/media/arrow_drop_down_circle_black.a07fe5ae.svg";